<template>
  <div class="swiperDevotion">
    <div class="title">
      <a href="javascript:;"
         class="return"
         @click="$router.go(-1)"><em class="iconfont">&#xe7b0;</em>{{$t('back')}}</a> {{$t('issue')}} {{obj.title}}{{$t('stage')}}</div>

    <div ref="mySwiper"
         class="swiper-container swiper-container-devotion">
      <div class="swiper-wrapper">
        <div class="swiper-slide swiper-lazy"
             v-for="item in setScreenWidth < 768 ? obj.p : obj.p"
             :key="item">
          <img width="100%"
               :data-src=" `${carousel.front}${item}${carousel.after}`"
               :preview="item"
               class="imgA  swiper-lazy">
          <!-- <img width="100%"
               :data-src="`${url}devotion/35/devotion35 (${item}).jpg`"
               :preview="`a${item}`"
               class="imgA swiper-lazy imgA768"> -->
          <div class="swiper-lazy-preloader"></div>

          <!-- <div class="imgA devotionImg swiper-lazy"
               :data-background="`${url}devotion/35/devotion35 (${item}).jpg`"
               :preview="item">
            <div class="swiper-lazy-preloader"></div>
          </div> -->

          <!-- <div class="imgA devotionImg swiper-lazy devotionImg768"
               :data-background="`${url}devotion/36/devotion35 (${item}).jpg`"
               :preview="item">
            <div class="swiper-lazy-preloader"></div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="swiper-button-next swiper-button-next-a iconfont icon-jiantou"
         slot="navigation"></div>
    <div class="swiper-button-prev swiper-button-prev-a iconfont icon-fanhui"
         slot="navigation"></div>

    <div ref="mySwiperThumbnail"
         class="swiper-container swiper-container-devotionThumbnail">
      <div class="swiper-wrapper">
        <!-- <div class="btn-put">a</div> -->
        <div :class="['swiper-slide',  'swiper-lazy', (itemThumbnail-1) == thumbnailLiIndex || (itemThumbnail-1) == thumbnailCurrent ? 'current' : '']"
             v-for="itemThumbnail in setScreenWidth < 768 ? obj.p : obj.p"
             :key="itemThumbnail">
          <em class="pageNum">
            {{itemThumbnail}}
          </em>

          <div class="imgA swiper-lazy"
               :data-background="`${carousel.front}${itemThumbnail}${carousel.after}`">
            <div class="swiper-lazy-preloader"></div>
          </div>

          <!-- <div class="imgA swiper-lazy imgA768"
               :data-background="`${url}devotion/35/devotion35 (${itemThumbnail}).jpg`">
            <div class="swiper-lazy-preloader"></div>
          </div> -->

        </div>
      </div>

      <div class="swiper-button-next swiper-button-next-n iconfont icon-jiantou"
           slot="navigation"></div>
      <div class="swiper-button-prev swiper-button-prev-n iconfont icon-fanhui"
           slot="navigation"></div>
    </div>

    <div class="swiper-pagination-num">
      <div class="swiper-pagination"></div>
      <input type="text"
             placeholder=""
             name="pageNum"
             v-model="curPage"
             @change="inputPage($event)">
      <button @click="onPage">{{$t('goto')}}</button>
    </div>

    <!-- <pic-show :imgUrl="imgUrl"
              :imgShow="imgShow"
              :setScreenWidth="setScreenWidth"
              @closeimg="imgClose"></pic-show> -->
  </div>

</template>
<script>

import Swiper from "swiper";
import PicShow from '@/components/PicShow'
import { mapState } from 'vuex'

// import { videoPlayer } from 'vue-video-player'
// import 'video.js/dist/video-js.css'

// import vueMiniPlayer from 'vue-mini-player'
// import 'vue-mini-player/lib/vue-mini-player.css'

// Swiper2.use([Navigation, Pagination, EffectFade]);

export default {
  components: {
    PicShow
  },
  computed: {
    ...mapState['s_setScreenWidth']
  },
  data () {
    return {
      url: this.$store.state.baseURL + '/',
      imgShow: false,
      imgUrl: '',
      setScreenWidth: 1920,

      thumbnailCurrent: null,
      thumbnailLiIndex: 0,

      curindex: 1,
      curPage: '',
      carousel: {
        fileType: 'IMG',
        front: '',
        front_move: '',
        after: ').jpg',
        list: [
          { title: 36, p: 72, p_m: 144 },
          { title: 35, p: 70, p_m: 140 },
          { title: 34, p: 58, p_m: 116 },
          { title: 33, p: 58, p_m: 116 },
          { title: 32, p: 52, p_m: 104 },
          { title: 31, p: 54, p_m: 108 },
          { title: 30, p: 60, p_m: 120 },
          { title: 29, p: 48, p_m: 96 },
          { title: 28, p: 48, p_m: 96 },
          { title: 27, p: 48, p_m: 96 },
          { title: 26, p: 62, p_m: 124 },
          { title: 25, p: 56, p_m: 112 },
          { title: 24, p: 57, p_m: 114 },
          { title: 23, p: 58, p_m: 116 },
          { title: 22, p: 58, p_m: 116 },
          { title: 21, p: 56, p_m: 112 },
          { title: 20, p: 54, p_m: 108 },
          { title: 19, p: 44, p_m: 88 },
          { title: 18, p: 52, p_m: 104 },
          { title: 17, p: 48, p_m: 96 },
          { title: 16, p: 46, p_m: 92 },
          { title: 15, p: 56, p_m: 112 },
          { title: 14, p: 46, p_m: 92 },
          { title: 13, p: 52, p_m: 104 },
          { title: 12, p: 48, p_m: 96 },
          { title: 11, p: 47, p_m: 94 },
          { title: 10, p: 74, p_m: 148 },
          { title: '09', p: 38, p_m: 76 },
          { title: '08', p: 38, p_m: 76 },
          { title: '07', p: 36, p_m: 72 },
          { title: '06', p: 39, p_m: 78 },
          { title: '05', p: 42, p_m: 84 },
          { title: '04', p: 38, p_m: 76 },
          { title: '03', p: 32, p_m: 64 },
          { title: '02', p: 33, p_m: 66 },
          { title: '01', p: 32, p_m: 64 },
        ]
      },
      obj: {}
    }
  },
  created () {

  },
  computed: {

  },
    mounted () {
      let that = this
    let id = this.$route.params && this.$route.params.id
    if (id) {
      that.carousel.list.forEach(e => {
        if (e.title == id) {
          that.obj = e
          that.carousel.front = `${that.url}devotion/${id}/devotion${id} (`
          that.carousel.front_move = `${that.url}devotion/${id}/devotion${id} (`
        }
      })
    }
    that.setScreenWidth = document.body.clientWidth
    setTimeout(() => {
      that.initSwiper()
      that.$previewRefresh()
    }, 300)
  },
  methods: {

    //devotion轮播图
    initSwiper () {
      let that = this
      let url

      let devotionThumbnail = new Swiper(".swiper-container-devotionThumbnail", {
        observer: true,
        observeSlideChildren: true,
        // slidesPerView: 5,
        // slidesPerView: that.slidesPerView,
        breakpoints: {
          //当宽度大于等于320
          320: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          375: {
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          450: {
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
          550: {
            slidesPerView: 7,
            slidesPerGroup: 7,
          },
          768: {
            slidesPerView: 8,
            slidesPerGroup: 8,
          },
          1000: {
            slidesPerView: 7,
            slidesPerGroup: 7,
          },
          1440: {
            slidesPerView: 10,
            slidesPerGroup: 10,
          },
          1600: {
            slidesPerView: 12,
            slidesPerGroup: 12,
          },
          1700: {
            slidesPerView: 13,
            slidesPerGroup: 13,
          },
          1920: {
            slidesPerView: 14,
            slidesPerGroup: 14,
          }
        },
        lazy: {
          loadPrevNext: true,
        },
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        passiveListeners: false,
        // on: {
        //   touchStart (e) {
        //     this.onon = false
        //     e.preventDefault()
        //   },
        //   touchMove (e) {
        //     this.onon = false
        //     e.preventDefault()
        //   },
        //   touchEnd (e) {
        //     e.preventDefault()
        //   },
        //   sliderMove (e) {
        //     e.preventDefault()
        //   }
        // },
        navigation: {
          nextEl: '.swiper-button-next-n', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev-n', //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
        },
      })

      let devotionImg = new Swiper(".swiper-container-devotion", {
        effect: "slide",
        activeIndex: 0,
        spaceBetween: 0,
        // autoHeight: true,
        observer: true,
        observeParents: true,
        loop: false,
        preventClicks: false,//默认true
        slidesPerView: 1,
        centeredSlides: true,
        fadeEffect: {
          crossFade: true,
        },
        on: {
          tap (e) {
            if (that.setScreenWidth < 768) {
              url = that.carousel.front_move + (this.clickedIndex + 1) + that.carousel.after
            } else {
              url = that.carousel.front + (this.clickedIndex + 1) + that.carousel.after
            }
            if (e.target.className.substring(0, 4) == 'imgA') {
              that.imgShow = true
              that.imgUrl = url
            }
          },

          slideChangeTransitionStart (e) {
            if (devotionImg.activeIndex != that.thumbnailLiIndex) {
              that.thumbnailLiIndex = devotionImg.activeIndex
              devotionThumbnail.slideTo(that.thumbnailLiIndex, 1000, true)
            }
          },
          transitionEnd (e) {
            if (devotionImg.activeIndex != that.thumbnailLiIndex) {
              that.thumbnailLiIndex = devotionImg.activeIndex
            }
          },
        },
        lazy: {
          loadPrevNext: true,
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next-a', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev-a', //后退按钮的css选择器或HTML元素。
          hideOnClick: true, //点击slide时显示/隐藏按钮
          disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
          hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
        },
        thumbs: {
          swiper: devotionThumbnail,
        }
      });

    },
    imgClose () {
      this.imgShow = false;
    },
    inputPage (e) {
      this.curPage = e.target.value
      this.$refs.mySwiper.swiper.slideTo(this.curPage * 1 - 1, 1000, true)
    },
    onPage () {
      this.$refs.mySwiper.swiper.slideTo(this.curPage * 1 - 1, 1000, true)
    }
  },
  watch: {
    '$store.state.s_setScreenWidth' (newsVal) {
      setTimeout(() => {
        this.setScreenWidth = newsVal
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
// @import "../../../static/stylebody.css";
.imgA {
  display: block;
}
// .devotionImg768,
// .imgA768 {
//   display: none;
// }

.my-button-disabled {
  opacity: 0.01;
}

.swiperDevotion {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f6f6f6;
  .return {
    position: absolute;
    top: 20px;
    left: 18px;
    width: 80px;
    font-size: 16px;
    color: $color-fff;
    em {
      margin-right: 10px;
      font-size: 16px;
    }
  }
  .title {
    position: absolute;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    width: 100%;
    height: 60px;
    background: #444;
    color: #fff;
    z-index: 2;
  }

  .swiper-button-next-a,
  .swiper-button-prev-a {
    position: absolute;
    top: 50%;
    margin-top: -50px;
    width: 50px;
    height: 100px;
    color: #666660;
    background-image: none;
    font-size: 54px;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    -webkit-transition: all 0s linear;
    -o-transition: all 0s linear;
    transition: all 0s linear;

    &:before {
      color: #cc1d3a;
      background-size: contain;
      -webkit-transition: all 0.2s ease-in-out;
      -o-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;
    }
    &:hover {
      font-size: 70px;
    }
  }
  .swiper-button-next-a {
    right: 0;
  }
  .swiper-button-prev-a {
    left: 0;
  }

  .swiper-button-next-n,
  .swiper-button-prev-n {
    position: absolute;
    top: 50%;
    margin-top: -50px;
    width: 50px;
    height: 100px;
    color: #666660;
    background-image: none;
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    -webkit-transition: all 0s linear;
    -o-transition: all 0s linear;
    transition: all 0s linear;

    &:before {
      color: #fff;
      background-size: contain;
      -webkit-transition: all 0.2s ease-in-out;
      -o-transition: all 0.2s ease-in-out;
      transition: all 0.2s ease-in-out;
    }
    &:hover {
      font-size: 34px;
    }
  }
  .swiper-button-next-a {
    right: 0;
  }
  .swiper-button-prev-a {
    left: 0;
  }
}

.swiper-container-devotion {
  padding: 2% 0;
  width: 96%;
  height: 96%;
  .swiper-slide {
    position: relative;
    // overflow-x: auto;

    display: flex;
    justify-content: center;
    align-items: center;

    .devotionImg {
      width: 100%;
      // height: 680px;
      height: 100%;
      background-size: contain;
      background-position: 50% 50%;
      background-repeat: no-repeat;
      cursor: pointer;
    }
    img {
      max-width: 1200px;
      max-height: 800px;
      margin: 0 auto;
      cursor: pointer;
    }
  }
}

.swiper-container-devotionThumbnail {
  width: 100%;
  height: 10%;
  position: absolute !important;
  bottom: 0;
  z-index: 3 !important;

  .swiper-slide {
    text-align: center;
    height: 100%;
    background: #444;
    border: 3px solid rgba(0, 0, 0, 0);
    .imgA {
      width: 100%;
      height: 100%;
      margin: 0 auto;
      cursor: pointer;
      opacity: 0.55;
      border: 2px solid rgba(0, 0, 0, 0.5);
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }
    .pageNum {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 4;
      color: #fff;
      font-size: 18px;
      font-style: normal;
      width: 100%;
      height: 20px;
      background: rgba(0, 0, 0, 0.5);
    }
  }
  .current {
    .imgA {
      opacity: 1;
      border: 2px solid #fff;
    }
  }
}

.swiper-pagination {
  display: inline-block !important;
  width: 80px !important;
  position: initial !important;
}
.swiper-pagination-num {
  display: inline-block;
  position: absolute !important;
  bottom: calc(10% + 6px);
  right: calc(1% + 6px);
  z-index: 4 !important;
  width: 100%;
  text-align: right;
  font-size: 18px;
  input {
    display: inline-block;
    width: 40px;
    margin-left: 6px;
    text-align: center;
  }
  button {
    display: inline-block;
  }
}

@media (max-width: 1600px) {
  .swiper-container-devotion {
    .swiper-slide {
    }
  }
}

@media (max-width: 1440px) {
}
@media (max-width: 1300px) {
  .video-player-close {
    right: 50%;
    margin-right: -42%;
  }
  // .swiper-container-devotion {
  //   padding: 100px 0;
  //   width: 96%;
  //   height: 96%;
  //   .swiper-slide {
  //     img {
  //       width: 1000px;
  //       height: 668px;
  //       min-height: 668px;
  //       margin: 0 auto;
  //       cursor: pointer;
  //     }
  //   }
  // }
}

@media (max-width: 1000px) {
  .video-player {
    width: 100%;
    margin-left: 0;
    left: 0;
  }
  .video-player-close {
    right: 10%;
  }
  // .swiper-container-devotion {
  //   .swiper-slide {
  //     img {
  //       width: 800px;
  //       height: 534px;
  //       min-height: 534px;
  //       margin: 0 auto;
  //       cursor: pointer;
  //     }
  //   }
  // }
}

@media (max-width: 768px) {
  .swiper-slide {
    // .devotionImg,
    // .imgA {
    //   display: none;
    // }
    // .devotionImg768,
    // .imgA768 {
    //   display: block;
    // }
    // img {
    //   width: 100%;
    //   margin: 0 auto;
    //   cursor: pointer;
    // }
  }
}

@media (max-width: 500px) {
  .swiperDevotion {
    .return {
      left: 10px;
      em {
        font-size: 13px;
        margin-right: 4px;
      }
    }
  }
  .video-player-close {
    top: 17px;
    right: 17px;
    width: 28px;
    height: 28px;
    &::after {
      margin-right: -9px;
      margin-top: -10px;
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/news/DevotionSwiper.vue